import { register } from '../apiRegistry';
import apiService from '../apiService';

// University onboarding (Screen 1)
register({
  'admin/university-list': async (params) => {
    const queryParams = new URLSearchParams();
    if (params?.status) queryParams.append('status', params.status);
    if (params?.type) queryParams.append('type', params.type);
    if (params?.q) queryParams.append('q', params.q);
    queryParams.append('page', params?.page?.toString() || '1');
    queryParams.append('limit', params?.limit?.toString() || '20');
    return await apiService.get(`university?${queryParams.toString()}`);
  },

  'admin/university-detail': async (params) => {
    return await apiService.get(`university/${params?.universityId}`);
  },

  'admin/university-create': async (payload) => {
    return await apiService.post('university', payload);
  },

  'admin/university-update': async (params) => {
    return await apiService.put(`university/${params?.universityId}`, params?.data);
  },

  'admin/university-catalog': async (params) => {
    return await apiService.get(`university/${params?.universityId}/catalog`);
  },
});

// Sales intake + approval (Screen 2)
register({
  'admin/sales-intake-list': async (params) => {
    const queryParams = new URLSearchParams();
    if (params?.status) queryParams.append('status', params.status);
    if (params?.sale_type) queryParams.append('sale_type', params.sale_type);
    if (params?.q) queryParams.append('q', params.q);
    queryParams.append('page', params?.page?.toString() || '1');
    queryParams.append('limit', params?.limit?.toString() || '20');
    return await apiService.get(`sales?${queryParams.toString()}`);
  },

  'admin/sales-intake-statistics': async () => {
    return await apiService.get('sales/stats/summary');
  },

  'admin/sales-intake-detail': async (params) => {
    return await apiService.get(`sales/${params?.saleLeadId}`);
  },

  'admin/sales-intake-create': async (payload) => {
    return await apiService.post('sales', payload);
  },

  'admin/sales-intake-update': async (params) => {
    return await apiService.put(`sales/${params?.saleLeadId}`, params?.data);
  },

  'admin/sales-intake-approve': async (params) => {
    return await apiService.post(`sales/${params?.saleLeadId}/review`, { decision: 'approve' });
  },

  'admin/sales-intake-reject': async (params) => {
    return await apiService.post(`sales/${params?.saleLeadId}/review`, { decision: 'reject', reason: params?.reason });
  },

  'admin/sales-intake-reopen': async (params) => {
    return await apiService.post(`sales/${params?.saleLeadId}/reopen`, { reason: params?.reason });
  },
});
